import { Loader2 } from "lucide-react";

export function Loading({ label = "Loading…", testid = "loading-state" }) {
  return (
    <div data-testid={testid} className="flex items-center justify-center py-20 text-slate-500">
      <Loader2 className="h-5 w-5 animate-spin mr-2 text-teal" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function SkeletonCards({ count = 4 }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="h-28 rounded-xl bg-white border border-slate-200 animate-pulse" />
      ))}
    </div>
  );
}

export function ErrorState({ message = "Something went wrong", onRetry, testid = "error-state" }) {
  return (
    <div data-testid={testid} className="flex flex-col items-center justify-center py-16 text-center">
      <p className="text-sm text-rose-600 font-medium">{message}</p>
      {onRetry && (
        <button onClick={onRetry} className="mt-4 text-sm font-semibold text-teal hover:underline" data-testid="error-retry-btn">
          Try again
        </button>
      )}
    </div>
  );
}
